<template>
  <div>
    <template v-if="disabled">
      <pre class="text-primary" :style="textareaMinHeightStyle">{{ data }}</pre>
    </template>
    <el-input
      type="textarea"
      v-else
      v-model="data"
      :maxlength="option.maxlength || 2000"
      show-word-limit
      :placeholder="
        option.placeholder
          ? option.placeholder
          : $t('_components.placeholder.input') + label
      "
      :rows="option.textareaRows || 3"
    />
  </div>
</template>

<script>
import { BFormTextarea } from 'bootstrap-vue'

export default {
  components: {
    BFormTextarea,
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: undefined,
    }
  },
  computed: {
    textareaMinHeightStyle() {
      const rows = Number(this.option.textareaRows)
      if (!rows) return null
      return { minHeight: `${rows * 23 + 10}px` }
    },
  },
  watch: {
    data: {
      deep: true,
      handler(e) {
        this.$emit('input', e)
      },
    },
    value: {
      handler(e) {
        this.data = e
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
pre {
  background: none;
  white-space: pre-wrap; /* 允许长行换行 */
  word-wrap: break-word;
}
</style>
